(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rsb-custom-lighting-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadGuide(scope) {
    const host = scope.querySelector('rsb-lighting-guide[data-script-url]');
    if (!host || customElements.get('rsb-lighting-guide') || document.querySelector('script[data-rsb-guide-loader]')) return;
    const script = document.createElement('script');
    script.src = host.dataset.scriptUrl;
    script.defer = true;
    script.dataset.rsbGuideLoader = '';
    document.head.append(script);
  }
  loadGuide(document);
  document.addEventListener('shopify:section:load', event => loadGuide(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
